export default "__VITE_ASSET__bb52a0d3__"